/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 8/3/2021
 * @Example
 */

export const types = {
    W09F2001_GET_GRID_HR: 'W09F2001_GET_GRID_HR',
    W09F2001_GET_CB_REPORT: 'W09F2001_GET_CB_REPORT',
    W09F2001_GET_CB_TRAN: 'W09F2001_GET_CB_TRAN',
    W09F2001_GET_CB_REPORT_HISTORY: 'W09F2001_GET_CB_REPORT_HISTORY',
};

export function getDataGridHR(params, cb) {
    return {
        type: types.W09F2001_GET_GRID_HR,
        params,
        cb
    }
}

export function getCbReport(params, cb) {
    return {
        type: types.W09F2001_GET_CB_REPORT,
        params,
        cb
    }
}

export function getCbTran(params, cb) {
    return {
        type: types.W09F2001_GET_CB_TRAN,
        params,
        cb
    }
}